import type { SvgProps } from 'react-native-svg';
import Svg, { Path } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface ArrowDownFilledIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const ArrowDownFilledIcon = ({
  size = 12,
  color = 'iconPrimary',
  ...props
}: ArrowDownFilledIconProps) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox="0 0 9 4" fill="none" {...props}>
      <Path
        d="M5.16436 3.40945C4.78548 3.74624 4.21452 3.74624 3.83564 3.40945L0 0L9 0L5.16436 3.40945Z"
        fill={colors[color]}
      />
    </Svg>
  );
};
